/**
 * CKEditor5 translation languages used in the CC build
 */
import De from 'ckeditor5/translations/de.js';
import En from 'ckeditor5/translations/en.js';
import Pl from 'ckeditor5/translations/pl.js';
import Tr from 'ckeditor5/translations/tr.js';
import Es from 'ckeditor5/translations/es.js';
import It from 'ckeditor5/translations/it.js';
import Fr from 'ckeditor5/translations/fr.js';
import Nl from 'ckeditor5/translations/nl.js';

export default [De, En, Pl, Tr, Es, It, Fr, Nl];
